/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

export type GetApiSentEmailListSortBy = typeof GetApiSentEmailListSortBy[keyof typeof GetApiSentEmailListSortBy] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiSentEmailListSortBy = {
  sentAt: 'sentAt',
  department: 'department',
  from: 'from',
  to: 'to',
  subject: 'subject',
} as const;
